document.addEventListener("DOMContentLoaded", function () {
    const atcBtn = document.getElementById("bundle-atc-pdp");
    if (atcBtn) {
        atcBtn.addEventListener("click", function () {
            const mainBtn = this;
            mainBtn.setAttribute("disabled", "true");

            const bundleButton = document.querySelector(".add-bundle-to-cart");
            if (bundleButton) {
                bundleButton.click();
                setTimeout(() => {
                    mainBtn.removeAttribute("disabled");
                }, 3000);
            }
        });
    }
    const swatches = document.querySelectorAll(".same-product .swatch-color");
    swatches.forEach(function (swatch) {
        swatch.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();

            const variantId = swatch.getAttribute("data-variant-id");
            const selectedColor = swatch.getAttribute("data-option-value-name");
            const selectColorInput = document.querySelector(`.product__info-container variant-selects input[value="${selectedColor}"]`);
            const idOfSelectedColorInput = selectColorInput.id;
            let scrollLocked = false;
            let lastScrollY = 0;
            temporarilyPreventScroll();
            document.querySelector(`.product__info-container variant-selects label[for=${idOfSelectedColorInput}]`).click();
            function temporarilyPreventScroll() {
                lastScrollY = window.scrollY;
                scrollLocked = true;
                setTimeout(() => {
                    scrollLocked = false;
                }, 1000);
            }
            window.addEventListener('scroll', () => {
                if (scrollLocked) {
                    window.scrollTo(0, lastScrollY); // Geri al
                }
            });
            const sameProduct = swatch.closest(".same-product");
            if (sameProduct && variantId) {
                const variantInput = sameProduct.querySelector("input.product-variant-id");
                if (variantInput) {
                    variantInput.value = variantId;
                    setTimeout(() => {
                        updatePrice("update", variantId);
                    },500)
                }
            }
        });
    });

});

function updatePrice(type, variantInput) {
    const select = document.querySelector(".sticky-atc-bar__variant-select");
    // if (type === 'update') {
    //     if (variantInput) {
    //         select.value = variantInput;
    //         select.dispatchEvent(new Event('change', {bubbles: false}));
    //     }
    // }
    const main_discount_price = document.querySelector(".sticky-atc-bar__product .discount-message-price").innerHTML;
    const main_discount_price_text = document.querySelector(".sticky-atc-bar__product .discount-message-price").textContent;
    const regular_price = document.querySelector(".sticky-atc-bar__product .discounted-product-price .f-price-item--regular").innerHTML;
    const regular_price_text = document.querySelector(".sticky-atc-bar__product .discounted-product-price .f-price-item--regular").textContent;
    const compare_at_price = document.querySelector(".sticky-atc-bar__product .discounted-product-price .f-price-item--sale")?.innerHTML || "";
    const compare_at_price_text = document.querySelector(".sticky-atc-bar__product .discounted-product-price .f-price-item--sale")?.textContent || "";

    const same_main_discount_price = document.querySelector("product-listing .same-inner .discount-message-price");
    const same_regular_price = document.querySelector("product-listing .same-inner .f-price-item--regular");
    const same_compare_at_price = document.querySelector("product-listing .same-inner .f-price-item--sale");

    if (main_discount_price) {
        same_main_discount_price.innerHTML = main_discount_price;
        same_main_discount_price.style.display = 'block';
    }
    if(document.querySelector('.sticky-atc-bar__product .f-price').classList.contains("f-price--on-sale")) {
        //Compare Prices
        if(compare_at_price_text === regular_price_text){
            same_compare_at_price.style.display = 'none';
            same_regular_price.classList.add('pregular')
        }else{
            same_regular_price.classList.remove('pregular')
        }
        if (regular_price) {
            same_regular_price.innerHTML = regular_price;
            same_regular_price.style.display = 'block';
        }
        if (compare_at_price) {
            same_compare_at_price.innerHTML = compare_at_price;
            same_compare_at_price.style.display = 'block';
        }
    }else {
        //Regular Prices
        if(compare_at_price_text === regular_price_text){
            same_compare_at_price.style.display = 'none';
            same_regular_price.classList.add('pregular')
        }else{
            same_regular_price.classList.remove('pregular')
        }
        if (regular_price) {
            same_regular_price.innerHTML = regular_price;
            same_regular_price.style.display = 'block';
        }
        if (compare_at_price) {
            same_compare_at_price.style.display = 'none';
        }
    }
}


document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
        updatePrice("dispatch")
    },500)
})
